export default function() {
  return {
    restrict: 'E',
    controller: function($rootScope, $timeout) {
      'ngInject';
      return {
        link: function(scope, element) {
          var listener = function(event, toState) {
            var title = 'Prolaera';
            if (toState.data && toState.data.pageTitle) title = toState.data.pageTitle + ' | ' + title;
            $timeout(
              function() {
                element.text(title);
              },
              0,
              false
            );
          };

          $rootScope.$on('$stateChangeSuccess', listener);
        }
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/title/index.js